// Application constants and configuration

import { env } from './env';

// Application Configuration
export const APP_CONFIG = {
  NAME: env.VITE_APP_NAME,
  VERSION: env.VITE_APP_VERSION,
  ENVIRONMENT: env.VITE_APP_ENVIRONMENT,
  DESCRIPTION: 'Manage your MCP services and analytics on the AskiiMall marketplace',
} as const;

// API Configuration
export const API_CONFIG = {
  BASE_URL:
    env.VITE_APP_ENVIRONMENT !== 'development'
      ? env.VITE_API_BASE_URL.replace('http://', 'https://')
      : env.VITE_API_BASE_URL,
  TIMEOUT: 30000, // 30 seconds
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000, // 1 second
} as const;

// Pagination Configuration
export const PAGINATION_CONFIG = {
  DEFAULT_PAGE_SIZE: 10,
  MAX_PAGE_SIZE: 100,
  PAGE_SIZE_OPTIONS: [10, 25, 50, 100],
} as const;

// Cache Configuration
export const CACHE_CONFIG = {
  DEFAULT_TTL: 5 * 60 * 1000, // 5 minutes
  AUTH_TTL: 60 * 60 * 1000, // 1 hour
  ANALYTICS_TTL: 15 * 60 * 1000, // 15 minutes
} as const;

// Feature Flags
export const FEATURE_FLAGS = {
  ENABLE_ANALYTICS: true,
  ENABLE_PAYOUTS: true,
  ENABLE_NOTIFICATIONS: true,
  ENABLE_DARK_MODE: true,
  ENABLE_BETA_FEATURES: env.VITE_APP_ENVIRONMENT === 'development',
} as const;

// UI Configuration
export const UI_CONFIG = {
  SIDEBAR_WIDTH: 280,
  HEADER_HEIGHT: 64,
  FOOTER_HEIGHT: 48,
  MOBILE_BREAKPOINT: 768,
  TABLET_BREAKPOINT: 1024,
  DESKTOP_BREAKPOINT: 1280,
} as const;

// Validation Configuration
export const VALIDATION_CONFIG = {
  PASSWORD: {
    MIN_LENGTH: 8,
    MAX_LENGTH: 128,
    REQUIRE_UPPERCASE: true,
    REQUIRE_LOWERCASE: true,
    REQUIRE_NUMBERS: true,
    REQUIRE_SYMBOLS: false,
  },
  SERVICE_NAME: {
    MIN_LENGTH: 3,
    MAX_LENGTH: 100,
  },
  DESCRIPTION: {
    MAX_LENGTH: 1000,
  },
  TAGS: {
    MAX_COUNT: 10,
    MAX_LENGTH: 50,
  },
} as const;

// File Upload Configuration
export const UPLOAD_CONFIG = {
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/webp'],
  ALLOWED_DOCUMENT_TYPES: ['application/pdf', 'text/plain', 'text/markdown'],
} as const;

// Analytics Configuration
export const ANALYTICS_CONFIG = {
  DEFAULT_TIME_RANGE: '30d',
  TIME_RANGES: [
    { label: 'Last 7 days', value: '7d' },
    { label: 'Last 30 days', value: '30d' },
    { label: 'Last 90 days', value: '90d' },
    { label: 'Last year', value: '1y' },
  ],
  CHART_COLORS: [
    '#3b82f6', // blue
    '#10b981', // emerald
    '#f59e0b', // amber
    '#ef4444', // red
    '#8b5cf6', // violet
    '#06b6d4', // cyan
  ],
} as const;
